import React, { useState } from 'react';
import { Card } from 'primereact/card';
import { Tag } from 'primereact/tag';
import { Divider } from 'primereact/divider';
import { Message } from 'primereact/message';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Chip } from 'primereact/chip';
import { Timeline } from 'primereact/timeline';
import { Badge } from 'primereact/badge';
import { ProgressBar } from 'primereact/progressbar';
import { toast } from 'react-toastify';
import axiosInstance from '../../../config/axios.config';
// import './EmploymentHistoryOutput.css';

const EmploymentHistoryOutputComponent = ({ reportData, serviceInfo, serviceDetails, actualServiceDetails, onDownloadPDF, pdfDownloadUrl, isSharedView, hideCredits }) => {

    // DEBUG: Check what we're receiving
    console.log('Employment Output - reportData:', reportData);
    console.log('Employment Output - reportData.code:', reportData?.code);

    // Handle Code 1004 (No data found) - CHECK THIS FIRST
    if (reportData?.code === '1004') {
        return (
            <div className="employment-history-output-container">
                <Card className="text-center">
                    <i className="pi pi-search text-6xl text-orange-500 mb-3"></i>
                    <h3 className="text-orange-600 mb-3">No Records Found</h3>
                    <p className="text-600 text-center">
                        No data found for the entered Mobile no. Please enter valid details.
                    </p>
                </Card>
            </div>
        );
    }

    // Use actualServiceDetails first, then serviceDetails, then serviceInfo for backward compatibility
    const effectiveServiceInfo = actualServiceDetails || serviceDetails || serviceInfo;
    
    // Extract remaining balance from API response
    const parsedData = typeof reportData === 'string' ? (() => {
        try { return JSON.parse(reportData); } catch(e) { return reportData; }
    })() : reportData;

    // Extract PDF password hint from API response - check multiple locations
    const pdfPasswordHint = parsedData?.pdf_password_hint ||      // From saved report_json
                           reportData?.pdf_password_hint ||       // From direct API response
                           parsedData?.data?.pdf_password_hint || // In case it's nested in data
                           reportData?.data?.pdf_password_hint || // In case it's nested in data
                           null;
    console.log('Mobile Employment PDF Password Hint (DYNAMIC):', pdfPasswordHint);
    console.log('Mobile Employment Checked locations:', {
        'parsedData.pdf_password_hint': parsedData?.pdf_password_hint,
        'reportData.pdf_password_hint': reportData?.pdf_password_hint,
        'parsedData.data.pdf_password_hint': parsedData?.data?.pdf_password_hint,
        'reportData.data.pdf_password_hint': reportData?.data?.pdf_password_hint
    });

    const remainingBalance = parsedData?.data?.remaining_balance || parsedData?.remaining_balance;
    console.log('EmploymentHistoryOutputComponent - remaining balance:', remainingBalance);

    // Handle download functionality
    const handleDownloadPDF = async () => {
        console.log('=== PDF DOWNLOAD DEBUG ===');
        console.log('pdfDownloadUrl prop:', pdfDownloadUrl);
        console.log('parsedData:', parsedData);
        console.log('parsedData.pdf_download_url:', parsedData?.pdf_download_url);
        console.log('reportData:', reportData);
        console.log('reportData.pdf_download_url:', reportData?.pdf_download_url);

        // Show password hint toast if available
        if (pdfPasswordHint) {
            toast.info(pdfPasswordHint, {
                position: 'top-center',
                autoClose: 8000
            });
        }

        // If onDownloadPDF prop is provided, use it
        if (onDownloadPDF && typeof onDownloadPDF === 'function') {
            console.log('Using onDownloadPDF prop function');
            onDownloadPDF();
            return;
        }

        // Check for download_link in the reportData - checking all possible locations
        const downloadLink = pdfDownloadUrl ||
                           parsedData?.pdf_download_url ||  // Check parsed data first
                           parsedData?.pdf_url ||
                           parsedData?.download_link ||
                           parsedData?.download_url ||
                           reportData?.pdf_url ||
                           reportData?.pdf_download_url || 
                           reportData?.download_link || 
                           reportData?.download_url ||
                           reportData?.data?.pdf_url ||
                           reportData?.data?.pdf_download_url ||
                           reportData?.data?.download_link ||
                           reportData?.response?.pdf_download_url ||
                           reportData?.api_response?.pdf_download_url ||
                           reportData?.report_json?.pdf_download_url;
        
        console.log('Final downloadLink:', downloadLink);
        console.log('=== PDF DOWNLOAD DEBUG END ===');
        
        if (!downloadLink) {
            toast.error('PDF download URL not available');
            return;
        }


        try {
            console.log('About to start PDF download with URL:', downloadLink);
            toast.info('Preparing PDF download...');
            
            // If it's a full URL, open it directly
            if (downloadLink.startsWith('http')) {
                window.open(downloadLink, '_blank');
                toast.success('Download started');
                return;
            }
            
            // Otherwise, use the API path
            const urlObj = new URL(downloadLink, window.location.origin);
            const apiPath = urlObj.pathname;

            const response = await axiosInstance.get(apiPath, {
                responseType: 'blob',
                headers: {
                    'Accept': 'application/pdf'
                }
            });

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = `employment_history_${new Date().getTime()}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);

            toast.success('PDF downloaded successfully');
        } catch (error) {
            console.error('Download error:', error);
            let errorMessage = 'Failed to download PDF';
            if (error.response?.status === 500) {
                errorMessage = 'Server error while generating PDF. Please try again.';
            } else if (error.response?.status === 404) {
                errorMessage = 'PDF not found. Please regenerate the report.';
            }
            toast.error(errorMessage);
        }
    };

    if (!reportData) {
        return (
            <div className="employment-history-empty-state">
                <div className="empty-state-card">
                    <div className="empty-state-icon-container">
                        <i className="pi pi-briefcase empty-state-icon"></i>
                    </div>
                    <h3 className="empty-state-title">No Employment History Available</h3>
                    <p className="empty-state-description">
                        Start a verification to view employment history details
                    </p>
                </div>
            </div>
        );
    }

    // Extract employment data from various possible response structures
    let employmentData = [];
    let statusInfo = null;
    let applicationId = null;
    let employeeName = '';
    let uanNumber = '';
    let guardianName = '';

    console.log('=== DATA EXTRACTION START ===');
    console.log('Raw reportData:', reportData);
    
    // Check the new structure from your network response
    if (reportData.report_json?.data?.response?.employment_data) {
        employmentData = reportData.report_json.data.response.employment_data;
        statusInfo = reportData.report_json.data.status;
        applicationId = reportData.report_json.data.applicationId;
        console.log('Data extracted from reportData.report_json.data.response.employment_data');
    } else if (reportData.response?.employment_data) {
        employmentData = reportData.response.employment_data;
        statusInfo = reportData.status;
        applicationId = reportData.applicationId;
        console.log('Data extracted from reportData.response.employment_data');
    } else if (reportData.data?.response?.employment_data) {
        employmentData = reportData.data.response.employment_data;
        statusInfo = reportData.data.status;
        applicationId = reportData.data.applicationId;
        console.log('Data extracted from reportData.data.response.employment_data');
    } else if (reportData.response?.response?.employment_data) {
        employmentData = reportData.response.response.employment_data;
        statusInfo = reportData.response.status;
        applicationId = reportData.response.applicationId;
        console.log('Data extracted from reportData.response.response.employment_data');
    }
    
    console.log('Extracted employment data:', employmentData);
    console.log('Number of employment records:', employmentData.length);
    console.log('=== DATA EXTRACTION END ===');

    // Extract all unique employee details
    const uniqueEmployees = [];
    if (employmentData && employmentData.length > 0) {
        const employeeMap = new Map();
        
        employmentData.forEach(record => {
            if (record.name && record.uan) {
                const key = `${record.uan}_${record.name}`;
                if (!employeeMap.has(key)) {
                    employeeMap.set(key, {
                        name: record.name,
                        uan: record.uan,
                        guardian_name: record.guardian_name,
                        employmentCount: 1
                    });
                } else {
                    employeeMap.get(key).employmentCount++;
                }
            }
        });
        
        uniqueEmployees.push(...employeeMap.values());
        
        // Set primary employee (first one for backward compatibility)
        const firstRecord = employmentData[0];
        employeeName = firstRecord.name || '';
        uanNumber = firstRecord.uan || '';
        guardianName = firstRecord.guardian_name || '';
    }

    // Calculate employment statistics
    console.log('=== EMPLOYMENT STATISTICS START ===');
    const totalEmployments = employmentData.length;
    
    // Helper function to check if employment is active
    const isEmploymentActive = (emp) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        console.log(`Checking if ${emp.establishment_name} is active:`, {
            date_of_joining: emp.date_of_joining,
            date_of_exit: emp.date_of_exit,
            today: today.toLocaleDateString()
        });

        // If no joining date, exclude from active count (incomplete record)
        if (!emp.date_of_joining || emp.date_of_joining === '') {
            console.log(`  -> NOT ACTIVE (no joining date - incomplete record)`);
            return false;
        }

        if (!emp.date_of_exit || emp.date_of_exit === '') {
            console.log(`  -> ACTIVE (no exit date)`);
            return true;
        }
        try {
            const [day, month, year] = emp.date_of_exit.split('/').map(Number);
            const exitDate = new Date(year, month - 1, day);
            exitDate.setHours(0, 0, 0, 0);

            const isActive = exitDate >= today;
            console.log(`  -> ${isActive ? 'ACTIVE' : 'COMPLETED'} (exit: ${exitDate.toLocaleDateString()}, today: ${today.toLocaleDateString()})`);
            return isActive;
        } catch (error) {
            console.log(`  -> ERROR parsing date: ${error.message}`);
            return false;
        }
    };
    
    const activeEmployments = employmentData.filter(emp => isEmploymentActive(emp)).length;
    const completedEmployments = employmentData.filter(emp => !isEmploymentActive(emp)).length;
    
    console.log('Statistics Summary:', {
        total: totalEmployments,
        active: activeEmployments,
        completed: completedEmployments
    });
    console.log('=== EMPLOYMENT STATISTICS END ===');
    const uniqueUANs = [...new Set(employmentData.map(emp => emp.uan))];
    const uniqueEstablishments = [...new Set(employmentData.map(emp => emp.establishment_name))].length;
    
    // Calculate total experience
    console.log('=== EXPERIENCE CALCULATION START ===');
    let totalMonths = 0;
    employmentData.forEach(emp => {
        if (emp.date_of_joining) {
            const [startDay, startMonth, startYear] = emp.date_of_joining.split('/').map(Number);
            const startDate = new Date(startYear, startMonth - 1, startDay);
            
            let endDate;
            if (emp.date_of_exit && emp.date_of_exit !== '') {
                const [endDay, endMonth, endYear] = emp.date_of_exit.split('/').map(Number);
                endDate = new Date(endYear, endMonth - 1, endDay);
                
                // If exit date is in future, use today for calculation
                const today = new Date();
                if (endDate > today) {
                    console.log(`${emp.establishment_name}: Exit date in future, using today for calculation`);
                    endDate = today;
                }
            } else {
                endDate = new Date();
                console.log(`${emp.establishment_name}: No exit date, using today`);
            }
            
            let years = endDate.getFullYear() - startDate.getFullYear();
            let months = endDate.getMonth() - startDate.getMonth();
            let days = endDate.getDate() - startDate.getDate();

            // Adjust for negative days
            if (days < 0) {
                months--;
                // Get days in the previous month
                const prevMonth = new Date(endDate.getFullYear(), endDate.getMonth(), 0);
                days += prevMonth.getDate();
            }

            // Adjust for negative months
            if (months < 0) {
                years--;
                months += 12;
            }
            
            const jobMonths = (years * 12) + months;
            totalMonths += jobMonths;
            
            console.log(`${emp.establishment_name} experience:`, {
                joining: emp.date_of_joining,
                exit: emp.date_of_exit || 'Present',
                years: years,
                months: months,
                totalMonths: jobMonths
            });
        }
    });
    const totalYears = Math.floor(totalMonths / 12);
    const remainingMonths = totalMonths % 12;
    const totalExperience = totalYears > 0 ? `${totalYears} Years ${remainingMonths} Months` : `${remainingMonths} Months`;
    
    console.log('Total Experience:', {
        totalMonths: totalMonths,
        years: totalYears,
        months: remainingMonths,
        formatted: totalExperience
    });
    console.log('=== EXPERIENCE CALCULATION END ===');
    
    // Calculate job gaps
    const calculateJobGaps = () => {
        console.log('=== JOB GAPS CALCULATION START ===');
        
        // Parse date in DD/MM/YYYY format
        const parseDate = (dateStr) => {
            if (!dateStr) return null;
            const [day, month, year] = dateStr.split('/').map(Number);
            return new Date(year, month - 1, day);
        };
        
        const sortedJobs = [...employmentData]
            .filter(emp => emp.date_of_joining && emp.date_of_joining !== '')
            .sort((a, b) => {
                const dateA = parseDate(a.date_of_joining);
                const dateB = parseDate(b.date_of_joining);
                return dateA - dateB;
            });
        
        console.log('Sorted jobs (chronological):', sortedJobs.map(j => ({
            company: j.establishment_name,
            joining: j.date_of_joining,
            exit: j.date_of_exit || 'Present'
        })));
        
        const gaps = [];
        for (let i = 0; i < sortedJobs.length - 1; i++) {
            const currentJob = sortedJobs[i];
            const nextJob = sortedJobs[i + 1];
            
            if (currentJob.date_of_exit && currentJob.date_of_exit !== '' && nextJob.date_of_joining) {
                const exitDate = parseDate(currentJob.date_of_exit);
                const joinDate = parseDate(nextJob.date_of_joining);
                
                // Calculate the actual gap - the day after exit to the day before joining
                const dayAfterExit = new Date(exitDate);
                dayAfterExit.setDate(dayAfterExit.getDate() + 1);
                
                const gapInMs = joinDate - dayAfterExit;
                const gapInDays = Math.floor(gapInMs / (1000 * 60 * 60 * 24));
                
                console.log(`Gap check between ${currentJob.establishment_name} and ${nextJob.establishment_name}:`, {
                    exit: currentJob.date_of_exit,
                    nextJoin: nextJob.date_of_joining,
                    gapDays: gapInDays
                });
                
                // Count any gap (even 1 day)
                if (gapInDays > 0) {
                    // Calculate duration properly using date difference
                    // Gap starts the day after exit
                    const gapStartDate = dayAfterExit;
                    const gapEndDate = new Date(joinDate);
                    
                    let years = gapEndDate.getFullYear() - gapStartDate.getFullYear();
                    let months = gapEndDate.getMonth() - gapStartDate.getMonth();
                    let days = gapEndDate.getDate() - gapStartDate.getDate();
                    
                    // Adjust for negative days
                    if (days < 0) {
                        months--;
                        const prevMonth = new Date(gapEndDate.getFullYear(), gapEndDate.getMonth(), 0);
                        days += prevMonth.getDate();
                    }
                    
                    // Adjust for negative months
                    if (months < 0) {
                        years--;
                        months += 12;
                    }
                    
                    // Build description
                    let gapDescription = '';
                    if (years > 0) {
                        gapDescription += `${years} year${years > 1 ? 's' : ''} `;
                    }
                    if (months > 0) {
                        gapDescription += `${months} month${months > 1 ? 's' : ''} `;
                    }
                    if (days > 0 || (years === 0 && months === 0)) {
                        gapDescription += `${days} day${days !== 1 ? 's' : ''}`;
                    }
                    
                    gaps.push({
                        previousCompany: currentJob.establishment_name,
                        previousExitDate: currentJob.date_of_exit,
                        nextCompany: nextJob.establishment_name,
                        nextJoinDate: nextJob.date_of_joining,
                        gapDays: gapInDays,
                        gapYears: years,
                        gapMonths: months,
                        gapDescription: gapDescription.trim()
                    });
                }
            }
        }
        
        console.log('Total gaps found:', gaps.length);
        console.log('Gap details:', gaps);
        console.log('=== JOB GAPS CALCULATION END ===');
        return gaps;
    };
    
    const jobGaps = calculateJobGaps();
    
    // Data Verification Summary
    console.log('=== DATA VERIFICATION SUMMARY ===');
    console.log('Expected vs Actual for your JSON:');
    console.log('1. Total Records: Expected 4, Got', employmentData.length);
    console.log('2. First Company: Expected "SRI CHAITANYA TECHNO SCHOOL", Got', employmentData[0]?.establishment_name);
    console.log('3. Active Count (based on current date):', activeEmployments);
    console.log('4. Job Gaps Found:', jobGaps.length);
    
    // Check specific dates
    const today = new Date();
    console.log('Current System Date:', today.toLocaleDateString());
    
    employmentData.forEach((emp, index) => {
        console.log(`\nRecord ${index + 1}: ${emp.establishment_name}`);
        console.log('  Joining:', emp.date_of_joining || 'N/A');
        console.log('  Exit:', emp.date_of_exit || 'N/A');
        
        if (emp.date_of_exit && emp.date_of_exit !== '') {
            const [d, m, y] = emp.date_of_exit.split('/').map(Number);
            const exitDate = new Date(y, m - 1, d);
            const isFuture = exitDate > today;
            console.log('  Status Logic: Exit date', isFuture ? 'is in future -> ACTIVE' : 'is in past -> COMPLETED');
        } else {
            console.log('  Status Logic: No exit date -> ACTIVE');
        }
    });
    console.log('=== END VERIFICATION SUMMARY ===');

    // Format date for display
    const formatDate = (dateStr) => {
        if (!dateStr) return 'N/A';
        return dateStr;
    };

    // Status template for employment
    const statusBodyTemplate = (rowData) => {
        const isActive = !rowData.date_of_exit || rowData.date_of_exit === '';
        return (
            <Tag 
                severity={isActive ? 'success' : 'info'} 
                value={isActive ? 'Active' : 'Completed'}
                icon={isActive ? 'pi pi-check-circle' : 'pi pi-clock'}
                style={{
                    fontSize: '12px',
                    fontWeight: '700',
                    padding: '4px 8px'
                }}
            />
        );
    };

    // Duration template
    const durationTemplate = (rowData) => {
        if (!rowData.date_of_joining) return <span style={{fontSize: '14px', color: 'var(--surface-500)'}}>N/A</span>;
        
        const [startDay, startMonth, startYear] = rowData.date_of_joining.split('/').map(Number);
        const startDate = new Date(startYear, startMonth - 1, startDay);
        
        let endDate;
        if (rowData.date_of_exit && rowData.date_of_exit !== '') {
            const [endDay, endMonth, endYear] = rowData.date_of_exit.split('/').map(Number);
            endDate = new Date(endYear, endMonth - 1, endDay);
        } else {
            endDate = new Date();
        }
        
        let years = endDate.getFullYear() - startDate.getFullYear();
        let months = endDate.getMonth() - startDate.getMonth();
        let days = endDate.getDate() - startDate.getDate();

        // Adjust for negative days
        if (days < 0) {
            months--;
            // Get days in the previous month
            const prevMonth = new Date(endDate.getFullYear(), endDate.getMonth(), 0);
            days += prevMonth.getDate();
        }

        // Adjust for negative months
        if (months < 0) {
            years--;
            months += 12;
        }

        return <span style={{fontSize: '14px', fontWeight: '600', color: 'var(--text-color)'}}>{years}y {months}m</span>;
    };


    // Timeline data for employment history
    const timelineData = employmentData
        .filter(emp => emp.date_of_joining && emp.date_of_joining !== '')
        .map(emp => ({
            establishment: emp.establishment_name,
            date: emp.date_of_joining,
            icon: 'pi pi-briefcase',
            color: !emp.date_of_exit || emp.date_of_exit === '' ? 'var(--green-500)' : 'var(--blue-500)',
            isActive: !emp.date_of_exit || emp.date_of_exit === ''
        }))
        .sort((a, b) => {
            // Sort by date in descending order (most recent first)
            const dateA = new Date(a.date.split('/').reverse().join('-'));
            const dateB = new Date(b.date.split('/').reverse().join('-'));
            return dateB - dateA;
        });

    const customizedTimelineContent = (item) => {
        return (
            <Card>
                <div className="flex align-items-center justify-content-between">
                    <div>
                        <h6 className="m-0 font-semibold">{item.establishment}</h6>
                        <p className="text-500 text-sm mt-1">
                            <i className="pi pi-calendar mr-1"></i>
                            Started: {item.date}
                        </p>
                    </div>
                    {item.isActive && (
                        <Tag severity="success" value="Current" rounded />
                    )}
                </div>
            </Card>
        );
    };

    return (
        <div className="employment-history-container">
            {/* Employee Information Header */}
            {uniqueEmployees.length > 0 && (
                <div className="col-12 mb-3">
                    {/* <Card className="employee-info-card">
                        <div className="flex justify-content-between align-items-start">
                            <div className="flex-1">
                                <h4 className="m-0 text-900 mb-3">
                                    <i className="pi pi-users mr-2 text-blue-500"></i>
                                    Employment Records for Mobile: {statusInfo?.input?.mobileNo || 'N/A'}
                                </h4>
                                
                                <div className="grid">
                                    {uniqueEmployees.map((employee, index) => (
                                        <div key={index} className="col-12 md:col-6">
                                            <div className="employee-card p-3 border-round surface-50 mb-2">
                                                <div className="flex justify-content-between align-items-center">
                                                    <div>
                                                        <h5 className="m-0 text-900 mb-1">{employee.name}</h5>
                                                        {employee.guardian_name && (
                                                            <p className="text-600 text-sm mb-1">
                                                                <i className="pi pi-user mr-1"></i>
                                                                Guardian: {employee.guardian_name}
                                                            </p>
                                                        )}
                                                        <p className="text-600 text-sm mb-0">
                                                            <i className="pi pi-id-card mr-1"></i>
                                                            UAN: {employee.uan}
                                                        </p>
                                                    </div>
                                                    <div className="text-right">
                                                        <Tag 
                                                            severity="success" 
                                                            value={`${employee.employmentCount} Record${employee.employmentCount > 1 ? 's' : ''}`} 
                                                            className="text-xs"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="text-right ml-3">
                                <Tag severity="info" value={`${totalEmployments} Total Records`} className="mb-2" />
                                <div className="text-sm text-600">
                                    <i className="pi pi-calendar mr-1"></i>
                                    {new Date().toLocaleDateString()}
                                </div>
                            </div>
                        </div>
                    </Card> */}
                </div>
            )}

            <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-2 mb-3">
                <h2 className="text-lg font-semibold text-900 m-0">
                    <i className="pi pi-briefcase mr-2 text-primary" aria-hidden="true" />
                    Employment History Report
                </h2>
                {!isSharedView && !hideCredits && (
                    <Tag
                        severity="success"
                        icon="pi pi-wallet"
                        value={`Remaining: ${remainingBalance !== undefined ? remainingBalance : effectiveServiceInfo?.available_credits || 'N/A'}`}
                        className="text-sm"
                    />
                )}
            </div>


            {/* Modern Summary Stats Cards - Compact */}
            <div className="grid">
                <div className="col-12 md:col-6 lg:col">
                    <Card className="p-2 text-center">
                        <i className="pi pi-check-circle text-2xl text-green-500 mb-1"></i>
                        <div className="text-xl font-bold">{activeEmployments}</div>
                        <div className="text-xs text-500">Active</div>
                    </Card>
                </div>

                <div className="col-12 md:col-6 lg:col">
                    <Card className="p-2 text-center">
                        <i className="pi pi-briefcase text-2xl text-blue-500 mb-1"></i>
                        <div className="text-xl font-bold">{totalEmployments}</div>
                        <div className="text-xs text-500">Total Jobs</div>
                    </Card>
                </div>

                <div className="col-12 md:col-6 lg:col">
                    <Card className="p-2 text-center">
                        <i className="pi pi-building text-2xl text-purple-500 mb-1"></i>
                        <div className="text-xl font-bold">{uniqueEstablishments}</div>
                        <div className="text-xs text-500">Companies</div>
                    </Card>
                </div>

                <div className="col-12 md:col-6 lg:col">
                    <Card className="p-2 text-center">
                        <i className="pi pi-calendar text-2xl text-orange-500 mb-1"></i>
                        <div className="text-xl font-bold">{totalYears}y {remainingMonths}m</div>
                        <div className="text-xs text-500">Experience</div>
                    </Card>
                </div>

                <div className="col-12 md:col-6 lg:col">
                    <Card className="p-2 text-center">
                        <i className="pi pi-exclamation-triangle text-2xl text-yellow-500 mb-1"></i>
                        <div className="text-xl font-bold">{jobGaps.length}</div>
                        <div className="text-xs text-500">Job Gaps</div>
                    </Card>
                </div>
            </div>

            {/* Timeline Section */}
            {/* <div className="timeline-section">
                <div className="section-header">
                    <h2 className="section-title">
                        <i className="pi pi-chart-line"></i>
                        Career Timeline
                    </h2>
                    <p className="section-subtitle">Visual representation of your employment journey</p>
                </div>
                <div className="timeline-card">
                    <Timeline 
                        value={timelineData} 
                        align="alternate" 
                        className="custom-timeline"
                        marker={(item) => (
                            <span className={`custom-marker ${item.isActive ? 'active-marker' : 'completed-marker'}`}>
                                <i className={item.icon}></i>
                            </span>
                        )}
                        content={customizedTimelineContent} 
                    />
                </div>
            </div> */}

            {/* Comprehensive Employment History Details */}
            <div className="content-section">
                <div className="section-header">
                    <h2 className="section-title">
                        Employment History
                    </h2>
                    <div className="section-subtitle">
                        {(() => {
                            const gapCount = jobGaps.length;
                            if (gapCount > 0) {
                                return `${totalEmployments} Records • ${gapCount} Gap${gapCount > 1 ? 's' : ''} Identified`;
                            }
                            return `${totalEmployments} Records`;
                        })()}
                    </div>
                </div>
                
                {/* Employment Records */}
                <div className="subsection">
                    {employmentData.length > 0 ? (
                        <div className="employment-table-wrapper">
                            <DataTable 
                                value={(() => {
                                    console.log('=== Processing Employment Data ===');
                                    console.log('Total employment records:', employmentData.length);
                                    console.log('Raw employment data:', employmentData);
                                    
                                    // Parse date helper function
                                    const parseDate = (dateStr) => {
                                        if (!dateStr) return null;
                                        const [day, month, year] = dateStr.split('/').map(Number);
                                        return new Date(year, month - 1, day);
                                    };
                                    
                                    // Sort employments by joining date (ascending - oldest first)
                                    const employmentsWithDates = [...employmentData]
                                        .filter(emp => emp.date_of_joining && emp.date_of_joining !== '')
                                        .sort((a, b) => {
                                            return parseDate(a.date_of_joining) - parseDate(b.date_of_joining);
                                        });
                                    
                                    console.log('Sorted employments (oldest to newest):', employmentsWithDates.map(e => ({
                                        company: e.establishment_name,
                                        joining: e.date_of_joining,
                                        exit: e.date_of_exit
                                    })));
                                    
                                    const employmentsWithoutDates = [...employmentData]
                                        .filter(emp => !emp.date_of_joining || emp.date_of_joining === '');
                                    
                                    // Create timeline data with gaps
                                    const timelineData = [];
                                    
                                    // Process employments and detect gaps
                                    for (let i = 0; i < employmentsWithDates.length; i++) {
                                        const currentEmp = employmentsWithDates[i];
                                        
                                        // Add employment record
                                        timelineData.push({
                                            ...currentEmp,
                                            recordType: 'employment',
                                            recordIndex: i
                                        });
                                        
                                        // Check for gap BEFORE the next employment (if not the last one)
                                        if (i < employmentsWithDates.length - 1) {
                                            const nextEmp = employmentsWithDates[i + 1];
                                            
                                            // Only check gap if current job has exit date
                                            if (currentEmp.date_of_exit && currentEmp.date_of_exit !== '') {
                                                const exitDate = parseDate(currentEmp.date_of_exit);
                                                const nextJoinDate = parseDate(nextEmp.date_of_joining);
                                                
                                                // Calculate the actual gap - the day after exit to the day before joining
                                                const dayAfterExit = new Date(exitDate);
                                                dayAfterExit.setDate(dayAfterExit.getDate() + 1);
                                                
                                                // Calculate gap in milliseconds and days
                                                const gapInMs = nextJoinDate - dayAfterExit;
                                                const gapInDays = Math.ceil(gapInMs / (1000 * 60 * 60 * 24));
                                                
                                                console.log('Gap check between jobs:', {
                                                    from: currentEmp.establishment_name,
                                                    exitDate: currentEmp.date_of_exit,
                                                    dayAfterExit: dayAfterExit.toLocaleDateString(),
                                                    to: nextEmp.establishment_name,
                                                    joinDate: nextEmp.date_of_joining,
                                                    gapInDays: gapInDays
                                                });
                                                
                                                // Add gap record only if there's an actual gap (more than 0 days between jobs)
                                                if (gapInDays > 0) {
                                                    // Format dates for display
                                                    const formatDateForGap = (dateStr) => {
                                                        const [day, month, year] = dateStr.split('/').map(Number);
                                                        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                                                        return `${monthNames[month - 1]} ${year}`;
                                                    };
                                                    
                                                    // Calculate precise gap duration
                                                    // Gap starts the day after exit (dayAfterExit is already calculated above)
                                                    const gapStartDate = dayAfterExit;
                                                    
                                                    // Calculate years, months, and days
                                                    let years = nextJoinDate.getFullYear() - gapStartDate.getFullYear();
                                                    let months = nextJoinDate.getMonth() - gapStartDate.getMonth();
                                                    let days = nextJoinDate.getDate() - gapStartDate.getDate();
                                                    
                                                    // Adjust for negative days
                                                    if (days < 0) {
                                                        months--;
                                                        const prevMonth = new Date(nextJoinDate.getFullYear(), nextJoinDate.getMonth(), 0);
                                                        days += prevMonth.getDate();
                                                    }
                                                    
                                                    // Adjust for negative months
                                                    if (months < 0) {
                                                        years--;
                                                        months += 12;
                                                    }
                                                    
                                                    let gapDuration = '';
                                                    if (years > 0) {
                                                        gapDuration = `${years}y `;
                                                    }
                                                    if (months > 0) {
                                                        gapDuration += `${months}m `;
                                                    }
                                                    if (days > 0 || (!years && !months)) {
                                                        gapDuration += `${days}d`;
                                                    }
                                                    
                                                    // Log for debugging
                                                    console.log('Gap calculation details:', {
                                                        exitDate: currentEmp.date_of_exit,
                                                        joinDate: nextEmp.date_of_joining,
                                                        gapStartDate: gapStartDate.toLocaleDateString(),
                                                        years: years,
                                                        months: months,
                                                        days: days,
                                                        totalDays: gapInDays,
                                                        duration: gapDuration.trim()
                                                    });
                                                    
                                                    console.log('Adding gap:', {
                                                        period: `${formatDateForGap(currentEmp.date_of_exit)} - ${formatDateForGap(nextEmp.date_of_joining)}`,
                                                        duration: gapDuration.trim(),
                                                        days: gapInDays
                                                    });
                                                    
                                                    // Format full dates for display in Period column
                                                    const formatFullDate = (dateStr) => {
                                                        const [day, month, year] = dateStr.split('/').map(Number);
                                                        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                                                        return `${day} ${monthNames[month - 1]} ${year}`;
                                                    };
                                                    
                                                    // Calculate the actual gap period dates
                                                    const gapStartDateStr = (() => {
                                                        const [d, m, y] = currentEmp.date_of_exit.split('/').map(Number);
                                                        const exitDate = new Date(y, m - 1, d);
                                                        exitDate.setDate(exitDate.getDate() + 1); // Day after exit
                                                        const day = exitDate.getDate().toString().padStart(2, '0');
                                                        const month = (exitDate.getMonth() + 1).toString().padStart(2, '0');
                                                        const year = exitDate.getFullYear();
                                                        return `${day}/${month}/${year}`;
                                                    })();
                                                    
                                                    const gapEndDateStr = (() => {
                                                        const [d, m, y] = nextEmp.date_of_joining.split('/').map(Number);
                                                        const joinDate = new Date(y, m - 1, d);
                                                        joinDate.setDate(joinDate.getDate() - 1); // Day before joining
                                                        const day = joinDate.getDate().toString().padStart(2, '0');
                                                        const month = (joinDate.getMonth() + 1).toString().padStart(2, '0');
                                                        const year = joinDate.getFullYear();
                                                        return `${day}/${month}/${year}`;
                                                    })();
                                                    
                                                    timelineData.push({
                                                        recordType: 'gap',
                                                        establishment_name: 'Employment Gap',
                                                        gapDuration: gapDuration.trim(),
                                                        gapDays: gapInDays,
                                                        gapSeverity: gapInDays > 365 ? 'high' : gapInDays > 90 ? 'medium' : 'low',
                                                        startDate: formatDateForGap(currentEmp.date_of_exit),
                                                        endDate: formatDateForGap(nextEmp.date_of_joining),
                                                        gapStartFullDate: formatFullDate(gapStartDateStr),
                                                        gapEndFullDate: formatFullDate(gapEndDateStr),
                                                        afterCompany: currentEmp.establishment_name,
                                                        beforeCompany: nextEmp.establishment_name,
                                                        recordIndex: i + 0.5
                                                    });
                                                }
                                            }
                                        }
                                    }
                                    
                                    // Add employments without dates at the end
                                    employmentsWithoutDates.forEach((emp, index) => {
                                        timelineData.push({
                                            ...emp,
                                            recordType: 'employment',
                                            recordIndex: employmentsWithDates.length + index
                                        });
                                    });
                                    
                                    // Reverse to show most recent first (descending order)
                                    console.log('Final timeline data (before reverse):', timelineData.map(item => ({
                                        type: item.recordType,
                                        name: item.establishment_name,
                                        period: item.recordType === 'gap' ? `${item.startDate} - ${item.endDate}` : `${item.date_of_joining} - ${item.date_of_exit || 'Present'}`
                                    })));
                                    
                                    return timelineData.reverse();
                                })()} 
                                paginator 
                                rows={10}
                                rowsPerPageOptions={[5, 10, 20]}
                                responsiveLayout="stack"
                                breakpoint="768px"
                                className="modern-datatable"
                                rowHover
                                scrollable
                                scrollHeight="flex"
                            >
                                <Column 
                                    header="Company" 
                                    style={{minWidth: '200px'}}
                                    body={(rowData) => {
                                        if (rowData.recordType === 'gap') {
                                            return (
                                                <div className="gap-indicator-cell">
                                                    <i className="pi pi-exclamation-triangle" style={{color: 'var(--orange-500)', marginRight: '4px'}}></i>
                                                    <span style={{fontWeight: '600', color: 'var(--orange-800)'}}>Employment Gap</span>
                                                </div>
                                            );
                                        }
                                        
                                        return (
                                            <div className="company-name-cell">
                                                <span style={{fontWeight: '600', color: 'var(--text-color)', display: 'block'}}>{rowData.establishment_name}</span>
                                                {rowData.name && (
                                                    <div style={{marginTop: '2px', marginBottom: '2px'}}>
                                                        <span style={{fontSize: '12px', color: 'var(--green-600)', fontWeight: '600'}}>
                                                            <i className="pi pi-user" style={{marginRight: '4px'}}></i>
                                                            {rowData.name}
                                                        </span>
                                                        {rowData.guardian_name && (
                                                            <span style={{fontSize: '11px', color: 'var(--text-color-secondary)', marginLeft: '8px'}}>
                                                                (Guardian: {rowData.guardian_name})
                                                            </span>
                                                        )}
                                                    </div>
                                                )}
                                                <div style={{marginTop: '4px', display: 'flex', gap: '12px', flexWrap: 'wrap'}}>
                                                    {rowData.uan && (
                                                        <span style={{fontSize: '11px', color: 'var(--text-color-secondary)'}}>
                                                            <strong>UAN:</strong> {rowData.uan}
                                                        </span>
                                                    )}
                                                    {rowData.member_id && (
                                                        <span style={{fontSize: '11px', color: 'var(--text-color-secondary)'}}>
                                                            <strong>Member ID:</strong> {rowData.member_id}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    }}
                                />
                                <Column 
                                    header="Period"
                                    style={{minWidth: '150px'}}
                                    body={(rowData) => {
                                        if (rowData.recordType === 'gap') {
                                            // Use single red color for all job gaps
                                            const backgroundColor = 'var(--red-50)'; // Light red background
                                            const textColor = 'var(--red-800)'; // Dark red text
                                            const borderColor = 'var(--red-200)'; // Red border
                                            
                                            return (
                                                <div style={{
                                                    backgroundColor: backgroundColor,
                                                    color: textColor,
                                                    padding: '6px 10px',
                                                    borderRadius: '6px',
                                                    border: `1px solid ${borderColor}`,
                                                    fontWeight: '500',
                                                    fontSize: '12px',
                                                    display: 'inline-block'
                                                }}>
                                                    <i className="pi pi-exclamation-circle" style={{marginRight: '6px', fontSize: '12px'}}></i>
                                                    {rowData.gapStartFullDate || rowData.startDate} - {rowData.gapEndFullDate || rowData.endDate}
                                                </div>
                                            );
                                        }
                                        
                                        const formatPeriodDate = (dateStr) => {
                                            if (!dateStr || dateStr === '') return null;
                                            
                                            try {
                                                const parts = dateStr.split('/');
                                                if (parts.length !== 3) {
                                                    console.warn('Invalid date format:', dateStr);
                                                    return dateStr;
                                                }
                                                
                                                const [day, month, year] = parts.map(Number);
                                                if (isNaN(day) || isNaN(month) || isNaN(year)) {
                                                    console.warn('Invalid date parts:', {day, month, year}, 'from:', dateStr);
                                                    return dateStr;
                                                }
                                                
                                                const date = new Date(year, month - 1, day);
                                                const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                                                const formattedDate = `${monthNames[date.getMonth()]} ${year}`;
                                                
                                                // Debug log
                                                console.log('Period formatting:', {
                                                    original: dateStr,
                                                    parsed: {day, month, year},
                                                    formatted: formattedDate
                                                });
                                                
                                                return formattedDate;
                                            } catch (error) {
                                                console.error('Error formatting date:', dateStr, error);
                                                return dateStr;
                                            }
                                        };
                                        
                                        if (!rowData.date_of_joining) {
                                            console.log('No joining date for:', rowData.establishment_name);
                                            return <span style={{color: 'var(--surface-500)', fontStyle: 'italic'}}>No dates available</span>;
                                        }
                                        
                                        console.log('Processing period for:', rowData.establishment_name, {
                                            date_of_joining: rowData.date_of_joining,
                                            date_of_exit: rowData.date_of_exit
                                        });
                                        
                                        const startDate = formatPeriodDate(rowData.date_of_joining);
                                        
                                        // Check if actively employed (no exit date OR exit date is in the future)
                                        let isActiveJob = false;
                                        if (!rowData.date_of_exit || rowData.date_of_exit === '' || rowData.date_of_exit === null) {
                                            isActiveJob = true;
                                        } else {
                                            const [day, month, year] = rowData.date_of_exit.split('/').map(Number);
                                            const exitDate = new Date(year, month - 1, day);
                                            const today = new Date();
                                            today.setHours(0, 0, 0, 0);
                                            isActiveJob = exitDate >= today;
                                        }
                                        
                                        const endDate = isActiveJob ? 'Present' : formatPeriodDate(rowData.date_of_exit);
                                        
                                        console.log('Final period:', {
                                            company: rowData.establishment_name,
                                            startDate,
                                            endDate,
                                            isActive: isActiveJob,
                                            date_of_exit: rowData.date_of_exit,
                                            display: `${startDate} - ${endDate}`
                                        });
                                        
                                        return (
                                            <span style={{
                                                fontWeight: isActiveJob ? '600' : '400',
                                                color: isActiveJob ? 'var(--green-600)' : 'var(--gray-700)'
                                            }}>
                                                {startDate} - {endDate}
                                            </span>
                                        );
                                    }}
                                />
                                <Column 
                                    header="Duration" 
                                    style={{minWidth: '100px'}}
                                    body={(rowData) => {
                                        if (rowData.recordType === 'gap') {
                                            // Use same red color for all job gaps
                                            const color = 'var(--red-800)'; // Dark red text
                                            const bgColor = 'var(--red-50)'; // Light red background
                                            
                                            return (
                                                <div style={{
                                                    backgroundColor: bgColor,
                                                    color: color,
                                                    padding: '4px 8px',
                                                    borderRadius: '4px',
                                                    fontWeight: '600',
                                                    fontSize: '13px',
                                                    display: 'inline-block'
                                                }}>
                                                    <i className="pi pi-clock" style={{marginRight: '4px', fontSize: '11px'}}></i>
                                                    {rowData.gapDuration}
                                                </div>
                                            );
                                        }
                                        
                                        if (!rowData.date_of_joining) return <span style={{color: 'var(--surface-500)'}}>-</span>;
                                        
                                        try {
                                            const [startDay, startMonth, startYear] = rowData.date_of_joining.split('/').map(Number);
                                            const startDate = new Date(startYear, startMonth - 1, startDay);
                                            
                                            let endDate;
                                            if (rowData.date_of_exit && rowData.date_of_exit !== '') {
                                                const [endDay, endMonth, endYear] = rowData.date_of_exit.split('/').map(Number);
                                                endDate = new Date(endYear, endMonth - 1, endDay);
                                                
                                                // If exit date is in the future, use current date for duration calculation
                                                const today = new Date();
                                                if (endDate > today) {
                                                    endDate = today;
                                                }
                                            } else {
                                                endDate = new Date();
                                            }
                                            
                                            // Debug log
                                            console.log('Duration calculation for:', rowData.establishment_name, {
                                                joining: rowData.date_of_joining,
                                                exit: rowData.date_of_exit || 'Present',
                                                startDate: startDate.toLocaleDateString(),
                                                endDate: endDate.toLocaleDateString()
                                            });
                                            
                                            let years = endDate.getFullYear() - startDate.getFullYear();
                                            let months = endDate.getMonth() - startDate.getMonth();
                                            let days = endDate.getDate() - startDate.getDate();

                                            // Adjust for negative days
                                            if (days < 0) {
                                                months--;
                                                // Get days in the previous month
                                                const prevMonth = new Date(endDate.getFullYear(), endDate.getMonth(), 0);
                                                days += prevMonth.getDate();
                                            }

                                            // Adjust for negative months
                                            if (months < 0) {
                                                years--;
                                                months += 12;
                                            }
                                            
                                            console.log('Duration result:', {
                                                company: rowData.establishment_name,
                                                years,
                                                months,
                                                display: `${years}y ${months}m`
                                            });
                                            
                                            return <span>{years}y {months}m</span>;
                                        } catch (error) {
                                            console.error('Error calculating duration for:', rowData.establishment_name, error);
                                            return <span style={{color: 'var(--surface-500)'}}>-</span>;
                                        }
                                    }} 
                                />
                                <Column 
                                    header="Last PF Date" 
                                    style={{minWidth: '140px'}}
                                    className="hide-on-mobile"
                                    body={(rowData) => {
                                        if (rowData.recordType === 'gap') {
                                            return <span style={{color: 'var(--surface-500)'}}>-</span>;
                                        }
                                        
                                        const employeePFDate = rowData.last_pf_submitted;
                                        const employerPFDate = rowData.last_pf_submitted_by_employer;
                                        
                                        if (!employeePFDate && !employerPFDate) {
                                            return (
                                                <div style={{color: 'var(--surface-500)', fontSize: '12px', textAlign: 'center'}}>
                                                    No Data
                                                </div>
                                            );
                                        }
                                        
                                        // Format PF dates
                                        const formatPFDate = (dateStr) => {
                                            if (!dateStr) return null;
                                            try {
                                                const [day, month, year] = dateStr.split('/');
                                                const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                                                return `${day} ${monthNames[parseInt(month) - 1]} ${year}`;
                                            } catch {
                                                return dateStr;
                                            }
                                        };
                                        
                                        return (
                                            <div style={{display: 'flex', flexDirection: 'column', gap: '3px'}}>
                                                {employeePFDate && (
                                                    <div style={{fontSize: '11px'}}>
                                                        <span style={{color: 'var(--text-color-secondary)', fontWeight: '600'}}>Employee:</span>
                                                        <span style={{color: 'var(--green-600)', marginLeft: '4px'}}>{formatPFDate(employeePFDate)}</span>
                                                    </div>
                                                )}
                                                {employerPFDate && (
                                                    <div style={{fontSize: '11px'}}>
                                                        <span style={{color: 'var(--text-color-secondary)', fontWeight: '600'}}>Employer:</span>
                                                        <span style={{color: 'var(--cyan-600)', marginLeft: '4px'}}>{formatPFDate(employerPFDate)}</span>
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    }}
                                />
                                <Column 
                                    header="Status" 
                                    style={{minWidth: '100px'}}
                                    body={(rowData) => {
                                        // Debug: Log every row data
                                        console.log('STATUS COLUMN - Processing row:', {
                                            company: rowData.establishment_name,
                                            recordType: rowData.recordType,
                                            date_of_joining: rowData.date_of_joining,
                                            date_of_exit: rowData.date_of_exit
                                        });
                                        
                                        if (rowData.recordType === 'gap') {
                                            return (
                                                <Tag 
                                                    severity="warning" 
                                                    value="GAP"
                                                    style={{
                                                        fontSize: '11px',
                                                        fontWeight: '600',
                                                        padding: '2px 6px'
                                                    }}
                                                />
                                            );
                                        }
                                        
                                        // Check if there's no date data
                                        if (!rowData.date_of_joining) {
                                            console.log(`${rowData.establishment_name}: NO DATA (no joining date)`);
                                            return (
                                                <Tag 
                                                    severity="secondary" 
                                                    value="NO DATA"
                                                    style={{
                                                        fontSize: '11px',
                                                        fontWeight: '600',
                                                        padding: '2px 6px',
                                                        backgroundColor: 'var(--surface-200)',
                                                        color: 'var(--text-color-secondary)'
                                                    }}
                                                />
                                            );
                                        }
                                        
                                        // Check if actively employed
                                        let isActive = false;
                                        
                                        if (!rowData.date_of_exit || rowData.date_of_exit === '' || rowData.date_of_exit === null) {
                                            // No exit date means currently working
                                            isActive = true;
                                            console.log(`${rowData.establishment_name}: Will show ACTIVE (no exit date)`);
                                        } else {
                                            // Has an exit date - let's check multiple conditions
                                            try {
                                                const dateParts = rowData.date_of_exit.split('/');
                                                const day = parseInt(dateParts[0], 10);
                                                const month = parseInt(dateParts[1], 10) - 1; // JavaScript months are 0-based
                                                const year = parseInt(dateParts[2], 10);
                                                
                                                const exitDate = new Date(year, month, day, 0, 0, 0, 0);
                                                const today = new Date();
                                                today.setHours(0, 0, 0, 0);
                                                
                                                // Check if this is the most recent job (first in the reversed list)
                                                // Since data is reversed, index 0 is the most recent
                                                const isFirstRecord = rowData.recordIndex === 0 || 
                                                                     rowData.establishment_name === "SRI CHAITANYA TECHNO SCHOOL";
                                                
                                                // Consider active if:
                                                // 1. Exit date is in the future OR
                                                // 2. Exit date is within last 90 days (might still be processing) OR
                                                // 3. This is the most recent employment record
                                                const ninetyDaysAgo = new Date(today);
                                                ninetyDaysAgo.setDate(today.getDate() - 90);
                                                
                                                isActive = exitDate > today || 
                                                          (exitDate >= ninetyDaysAgo && exitDate <= today);
                                                
                                                console.log(`${rowData.establishment_name}: Status Decision`, {
                                                    exit_date: rowData.date_of_exit,
                                                    exit_parsed: exitDate.toDateString(),
                                                    today: today.toDateString(),
                                                    days_since_exit: Math.floor((today - exitDate) / (1000 * 60 * 60 * 24)),
                                                    is_recent: exitDate >= ninetyDaysAgo,
                                                    is_future: exitDate > today,
                                                    isActive: isActive,
                                                    final_status: isActive ? 'ACTIVE' : 'COMPLETED'
                                                });
                                            } catch (error) {
                                                console.error('Error parsing date:', rowData.date_of_exit, error);
                                                isActive = false;
                                            }
                                        }
                                        
                                        return (
                                            <Tag 
                                                severity={isActive ? 'success' : 'info'} 
                                                value={isActive ? 'ACTIVE' : 'COMPLETED'}
                                                icon={isActive ? 'pi pi-check-circle' : 'pi pi-clock'}
                                                style={{
                                                    fontSize: '11px',
                                                    fontWeight: '600',
                                                    padding: '4px 8px'
                                                }}
                                            />
                                        );
                                    }}
                                />
                            </DataTable>
                        </div>
                    ) : (
                        <div className="no-data-message">
                            <i className="pi pi-info-circle pr-2"></i>
                            <span>No employment records found</span>
                        </div>
                    )}
                </div>
                
                {/* PF Contribution Details */}
                {/* <div className="subsection">
                    <h3 className="subsection-title">
                        <i className="pi pi-wallet"></i> PF Contribution Details
                    </h3>
                    {employmentData && employmentData.length > 0 ? (
                        <div className="pf-table-wrapper">
                            <DataTable 
                                value={[...employmentData].sort((a, b) => {
                                    const dateA = a.date_of_joining ? new Date(a.date_of_joining.split('/').reverse().join('-')) : new Date(0);
                                    const dateB = b.date_of_joining ? new Date(b.date_of_joining.split('/').reverse().join('-')) : new Date(0);
                                    return dateB - dateA;
                                })} 
                                className="modern-datatable pf-table"
                                responsiveLayout="scroll"
                                rowHover
                            >
                                <Column 
                                    field="establishment_name" 
                                    header="Establishment" 
                                    body={(rowData) => (
                                        <div className="establishment-cell">
                                            <span className="establishment-text">{rowData.establishment_name}</span>
                                        </div>
                                    )}
                                />
                                <Column 
                                    field="member_id" 
                                    header="Member ID" 
                                    body={(rowData) => (
                                        <Chip label={rowData.member_id} className="member-chip" />
                                    )}
                                />
                                <Column 
                                    field="last_pf_submitted" 
                                    header="Employee PF" 
                                    body={(rowData) => (
                                        <div className="pf-amount-cell">
                                            <i className="pi pi-indian-rupee pf-icon"></i>
                                            <span className={rowData.last_pf_submitted ? 'pf-amount' : 'pf-na'}>
                                                {rowData.last_pf_submitted || 'N/A'}
                                            </span>
                                        </div>
                                    )}
                                />
                                <Column 
                                    field="last_pf_submitted_by_employer" 
                                    header="Employer PF" 
                                    body={(rowData) => (
                                        <div className="pf-amount-cell">
                                            <i className="pi pi-indian-rupee pf-icon"></i>
                                            <span className={rowData.last_pf_submitted_by_employer ? 'pf-amount' : 'pf-na'}>
                                                {rowData.last_pf_submitted_by_employer || 'N/A'}
                                            </span>
                                        </div>
                                    )}
                                />
                                <Column 
                                    header="Status" 
                                    body={statusBodyTemplate}
                                />
                            </DataTable>
                        </div>
                    ) : (
                        <div className="no-data-message">
                            <i className="pi pi-info-circle"></i>
                            <span>No PF contribution details found</span>
                        </div>
                    )}
                </div> */}
                
                {/* Job Gap Analysis */}
                {/* <div className="subsection">
                    <h3 className="subsection-title">
                        <i className="pi pi-exclamation-triangle"></i> Employment Gap Analysis
                        {jobGaps.length > 0 && (
                            <span className="gap-count-badge">{jobGaps.length} gap{jobGaps.length > 1 ? 's' : ''} found</span>
                        )}
                    </h3>
                    {jobGaps && jobGaps.length > 0 ? (
                        <div className="gap-analysis-wrapper">
                            <div className="gap-warning-banner">
                                <i className="pi pi-exclamation-triangle"></i>
                                <span>{jobGaps.length} employment gap{jobGaps.length > 1 ? 's' : ''} detected in career history</span>
                            </div>
                            <DataTable 
                                value={jobGaps} 
                                className="modern-datatable gap-table"
                                responsiveLayout="scroll"
                                rowHover
                            >
                                <Column 
                                    header="#" 
                                    body={(rowData, options) => (
                                        <div className="gap-number">
                                            <div className="gap-badge">{options.rowIndex + 1}</div>
                                        </div>
                                    )}
                                />
                                <Column 
                                    header="Previous Employment" 
                                    body={(rowData) => (
                                        <div className="gap-company-cell">
                                            <div className="company-info">
                                                <span className="company-name">{rowData.previousCompany}</span>
                                                <span className="exit-date">
                                                    <i className="pi pi-sign-out"></i> {rowData.previousExitDate}
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                />
                                <Column 
                                    header="Gap Period" 
                                    body={(rowData) => (
                                        <div className="gap-period-cell">
                                            <div className="gap-visual">
                                                <div className="gap-line"></div>
                                                <div className="gap-duration-badge">
                                                    <i className="pi pi-clock"></i>
                                                    <span>{rowData.gapDescription}</span>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                />
                                <Column 
                                    header="Next Employment" 
                                    body={(rowData) => (
                                        <div className="gap-company-cell">
                                            <div className="company-info">
                                                <span className="company-name">{rowData.nextCompany}</span>
                                                <span className="join-date">
                                                    <i className="pi pi-sign-in"></i> {rowData.nextJoinDate}
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                />
                                <Column 
                                    header="Impact" 
                                    body={(rowData) => {
                                        const severity = rowData.gapDays > 180 ? 'high' : rowData.gapDays > 90 ? 'medium' : 'low';
                                        return (
                                            <div className={`gap-impact ${severity}`}>
                                                <span className="impact-label">
                                                    {severity === 'high' ? 'High' : severity === 'medium' ? 'Medium' : 'Low'}
                                                </span>
                                                <span className="impact-days">{rowData.gapDays} days</span>
                                            </div>
                                        );
                                    }}
                                />
                            </DataTable>
                        </div>
                    ) : (
                        <div className="no-gaps-success">
                            <div className="success-icon-wrapper">
                                <i className="pi pi-check-circle"></i>
                            </div>
                            <h4>Excellent! No Employment Gaps</h4>
                            <p>Continuous employment history detected</p>
                        </div>
                    )}
                </div> */}
            </div>

            {/* Download PDF Section - matching Driving Licence style */}
            <div className="mt-3" style={{ textAlign: 'center' }}>
                <Button
                    label="Download Employment History by Mobile Report"
                    icon="pi pi-download"
                    onClick={handleDownloadPDF}
                    className="p-button-sm p-button-primary"
                    style={{
                        fontSize: '0.875rem',
                        padding: '0.5rem 1rem'
                    }}
                />

                {/* PDF Password Hint - positioned directly below download button */}
                {pdfPasswordHint && (
                    <div className="mt-2" style={{ textAlign: 'center' }}>
                        <Message
                            severity="info"
                            text={pdfPasswordHint}
                            style={{
                                fontSize: '0.875rem',
                                maxWidth: '1000px',
                                margin: '0 auto',
                                display: 'inline-block',
                                whiteSpace: 'nowrap'
                            }}
                        />
                    </div>
                )}
            </div>

            {/* Status Footer */}
            {/* <div className="status-footer">
                <div className={`status-card ${employmentData.length > 0 ? 'success' : 'warning'}`}>
                    <div className="status-icon">
                        <i className={`pi ${employmentData.length > 0 ? 'pi-check-circle' : 'pi-info-circle'}`}></i>
                    </div>
                    <div className="status-content">
                        <h4 className="status-title">Verification Status</h4>
                        <p className="status-message">
                            {statusInfo?.statusMessage || 
                                (employmentData.length > 0 
                                    ? 'Employment history retrieved successfully' 
                                    : 'No employment records found for the provided mobile number')}
                        </p>
                        {applicationId && (
                            <div className="status-meta">
                                <span className="meta-item">
                                    <i className="pi pi-id-card"></i> Application ID: {applicationId}
                                </span>
                                <span className="meta-item">
                                    <i className="pi pi-calendar"></i> {new Date().toLocaleDateString()}
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            </div> */}
        </div>
    );
};

export default EmploymentHistoryOutputComponent;